import { CLINICAL_ANALYSIS_TYPES_ACTIONS } from "constants/Actions/AnalysisClinicalTypes";

// Estado inicial del reducer
const aInitialState = {
    aActiveTypes: [],
    aAllTypes: [],
    oType: null,
    nNewId: null,
    aTypesSuggestion: [],
    // Arreglos para manejar metodologias y resultados al agregar resultado en análisis clínico
    aMethodologies: null,
    aResults: null,

    bIsSuccess: false,
    bIsError: false,
}
/**
 * Reducer que será utilizado para controlar los datos referidos a los tipos de análisis clínicos que admite el sistema.
 * 
 * @param {Array} aState Estado, si no recibe datos se setea el estado inicial
 * @param {object} oAction Action que es ejecutada
 * 
 * @returns {Array} Retorna un array que sera seteado en el estado del reducer
 * 
 * @author Leandro Curbelo 
 */
export const ClinicalAnalysisTypeReducer = (aState = aInitialState, oAction) => {
    switch (oAction.type) {
        case CLINICAL_ANALYSIS_TYPES_ACTIONS.GET_ACTIVE:
            return { ...aState, aActiveTypes: oAction.data.data, nTotalPages: oAction.data.pages };
        case CLINICAL_ANALYSIS_TYPES_ACTIONS.GET_ALL:
            return { ...aState, aAllTypes: oAction.data.data, nTotalPages: oAction.data.pages };    
        case CLINICAL_ANALYSIS_TYPES_ACTIONS.FIND:
            return { ...aState, oType: oAction.data };
        case CLINICAL_ANALYSIS_TYPES_ACTIONS.SUCCESS:
            return { ...aState, bIsSuccess: true, nNewId: oAction.data };
        case CLINICAL_ANALYSIS_TYPES_ACTIONS.ERROR:
            return { ...aState, bIsError: true };
        case CLINICAL_ANALYSIS_TYPES_ACTIONS.CLEAN:
            return { ...aState, oType: null, bIsSuccess: false, bIsError: false, aMethodologies: null, aResults: null };
        case CLINICAL_ANALYSIS_TYPES_ACTIONS.GET_METHODOLOGIES:
            return { ...aState, aMethodologies: oAction.data };
        case CLINICAL_ANALYSIS_TYPES_ACTIONS.GET_RESULTS:
            return { ...aState, aResults: oAction.data };
        default:
            return aState;
    }
}
